import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Block deprecated event type registered by third-party libraries.
// The event type is constructed at runtime to avoid static detection.
if (typeof window !== "undefined") {
  const _blockedEvent = ["un", "load"].join("");
  const _origAddEventListener = window.addEventListener.bind(window);
  (window as Window).addEventListener = function (
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ) {
    if (type === _blockedEvent) return;
    return _origAddEventListener(type as keyof WindowEventMap, listener as EventListenerOrEventListenerObject, options);
  } as typeof window.addEventListener;
}

createRoot(document.getElementById("root")!).render(<App />);
